module.exports = __webpack_public_path__ + "static/media/IR.f6903c10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/IR.svg
// module id = 2176
// module chunks = 7